 export const products = [
   {
    id: 1,
    img: "https://render.fineartamerica.com/images/images-profile-flow/400/images/artworkimages/mediumlarge/1/leader-of-the-pack-jerry-lofaro.jpg" ,
    link: "http://www.bellissimo.dev/",
   }, 
   {
    id: 2,
    img: "https://render.fineartamerica.com/images/rendered/search/print/8/8/break/images-medium-5/1-summer-on-the-farm-robin-moline.jpg",
    link: "http://www.lama.dev/",
   },
   {
    id: 3,
    img: "https://render.fineartamerica.com/images/images-profile-flow/400/images/artworkimages/mediumlarge/3/starstruck-peggy-collins.jpg",
    link:"http://www.bellissimo.dev/",
   },
   {
    id: 4,
    img: "https://render.fineartamerica.com/images/images-profile-flow/400/images/artworkimages/mediumlarge/3/betrayal-mario-sanchez-nevado.jpg",
    link: "http://www.bellissimo.dev/",
   },
   {
    id: 5,
    img:"https://render.fineartamerica.com/images/images-profile-flow/400/images/artworkimages/mediumlarge/3/tarkus-legacy-1-jerry-lofaro.jpg" ,
    link: "http://www.bellissimo.dev/",
   },
   {
    id: 6,
    img:"https://render.fineartamerica.com/images/images-profile-flow/400/images/artworkimages/mediumlarge/3/deliberation-mario-sanchez-nevado.jpg" ,
    link: "http://www.bellissimo.dev/",
   },  
];